// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import store from './store'
import App from '@/app'
import VueCookie from 'vue-cookie'
import '@/assets/scss/sb-admin-2.scss'
import 'jquery'
import 'bootstrap/dist/js/bootstrap.bundle.min'
import axios from 'axios'
import Loading from 'vue-loading-overlay'
Vue.use(Loading)
Vue.use(VueCookie)
Vue.config.productionTip = false
axios.defaults.baseURL = 'https://api.tech8.ru/'
// axios.defaults.baseURL = 'http://localhost:8081'
Vue.prototype.$http = axios
/* eslint-disable no-new */
new Vue({
  el: '#app',
  data () {
    return {
      loader: null
    }
  },
  router,
  store,
  created () {
    var hostname = window.location.hostname
    if (hostname !== 'localhost') {
      hostname = hostname.split('.')
      if (hostname.length === 3) this.$store.state.hostname = hostname[1] + '.' + hostname[2]
      else this.$store.state.hostname = hostname[0] + '.' + hostname[1]
    } else {
      this.$store.state.hostname = 'localhost'
    }
    const token = this.$cookie.get('user-token')
    if (token) axios.defaults.headers.common['Token'] = token
    axios.interceptors.request.use(config => {
      if (this.loader !== null && this.loader !== undefined) this.loader.hide()
      this.loader = Vue.$loading.show({
        loader: 'dots',
        opacity: 0.8,
        backgroundColor: 'transparent',
        color: '#54BB65',
        isFullPage: true
      })
      return config
    })
    axios.interceptors.response.use(response => {
      if (this.loader !== null && this.loader !== undefined) this.loader.hide()
      return response
    }, err => {
      if (this.loader !== null && this.loader !== undefined) this.loader.hide()
      return new Promise(function (resolve, reject) {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          // if you ever get an unauthorized, logout the user
          this.$store.dispatch('AUTH_LOGOUT')
          // you can also redirect to /login if needed !
        }
        throw err
      })
    })
    if (token) this.$store.dispatch('USER_REQUEST')
  },
  render: h => h(App)
})
router.beforeEach((to, from, next) => {
  if (this.loader !== null && this.loader !== undefined && to.name) {
    this.loader = Vue.$loading.show({
      loader: 'dots',
      opacity: 0.8,
      backgroundColor: 'transparent',
      color: '#54BB65',
      isFullPage: true
    })
  }
  next()
})

router.afterEach((to, from) => {
  if (this.loader !== null && this.loader !== undefined) this.loader.hide()
})



// WEBPACK FOOTER //
// ./src/main.js